import { useCallback } from "react";
import CoveragePhaseService from "../../../api/services/operation/coverage-phase-service";
import PhaseOperations from "../enum/PhaseOperations";

export function usePhaseDragAndDrop({
	selectedTab,
	activePhases,
	archivedPhases,
	projectId,
	getActivePhases,
	getArchivedPhases,
	updateCancelTokenSourceRef,
	setActivePhases,
	setArchivedPhases,
}) {
	const handleDragEnd = useCallback(
		(result) => {
			const { destination, source, draggableId } = result;
			const isSamePosition =
				destination?.index === source.index && destination?.droppableId === source.droppableId;

			if (!destination || isSamePosition) {
				return;
			}

			const displayedList = selectedTab === 0 ? activePhases : archivedPhases;
			const sourceIndex = source.index;
			const destinationIndex = destination.index;
			if (sourceIndex < 0 || sourceIndex >= displayedList.length) {
				return;
			}
			const draggedPhase = displayedList[sourceIndex];
			if (draggedPhase.id?.toString() !== draggableId) {
				return;
			}
			const destinationPhase = displayedList[destinationIndex];
			const phasesByPosition = [...displayedList].sort((a, b) => (a.position || 0) - (b.position || 0));
			const destinationPositionIndex = phasesByPosition.findIndex((p) => p.id === destinationPhase?.id);
			const previousId =
				destinationPositionIndex > 0 ? phasesByPosition[destinationPositionIndex - 1]?.id || null : null;
			const tempPhases = [...displayedList];
			const [removedPhase] = tempPhases.splice(sourceIndex, 1);
			tempPhases.splice(destinationIndex, 0, removedPhase);
			if (selectedTab === 0) {
				setActivePhases(tempPhases);
			} else {
				setArchivedPhases(tempPhases);
			}
			const updatedPhase = {
				...draggedPhase,
				previousPhaseId: previousId,
				operation: PhaseOperations.REORDER,
			};

			CoveragePhaseService.updateCoveragePhase(
				{
					projectId,
					phaseId: draggedPhase.id,
					phase: updatedPhase,
				},
				updateCancelTokenSourceRef.current.token
			)
				.then(() => {
					if (selectedTab === 0) {
						getActivePhases();
					} else {
						getArchivedPhases();
					}
				})
				.catch((err) => {
					console.error(`Failed to update phase ${draggedPhase.id} position:`, err);
					if (selectedTab === 0) {
						getActivePhases();
					} else {
						getArchivedPhases();
					}
				});
		},
		[
			selectedTab,
			activePhases,
			archivedPhases,
			projectId,
			getActivePhases,
			getArchivedPhases,
			updateCancelTokenSourceRef,
			setActivePhases,
			setArchivedPhases,
		]
	);

	return { handleDragEnd };
}
